import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { func, object, shape, string } from 'prop-types';
import Button from 'ps-components/Button/Button';
import { deleteJobMatch } from '../../JobMatching/OrgJobsActions';
import { hideModal } from '../../../actions/modal';
import './DeleteMatchesModal.scss';

class DeleteMatchesModal extends Component {
  static propTypes = {
    actions: shape({
      deleteJobMatch: func
    }),
    history: object,
    modal: object,
    modalProps: object,
    modalType: string
  };

  onDelete = () => {
    const { actions, modalProps } = this.props;
    actions.deleteJobMatch(modalProps.selectedSurveyJobs, modalProps.orgJob.id);
    actions.hideModal();
  };

  render() {
    return (
      <React.Fragment>
        <div className="modal__delete-title">
          <div className="icon-reverse icon-circle">
            <i className="icon icon-attention-alt" />
          </div>
          Confirmation
        </div>
        <div className="modal__delete-notes pxl-text-muted">
          Are you sure you want to delete the selected matches? Matches for market pricing cannot be deleted. You can
          delete them in Market Price a Job.
        </div>
        <div className="modal__delete-buttons">
          <a className="modal__delete-link" onClick={this.onCancel}>
            Cancel
          </a>
          <Button className="pxl-btn pxl-btn-primary" onClick={this.onDelete}>
            Delete Selected Matches
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteJobMatch, hideModal }, dispatch)
});

export default connect(null, mapDispatchToProps)(DeleteMatchesModal);
